import { FileExtensionType } from 'owa-files-filter-file-extensions-filter';
import { DateRangeFilter } from 'owa-files-filter-date-filter';

export const DEFAULT_IMAGE_SIZE: number = 50000;

export enum FilterType {
    Search,
    Size,
    ExtensionGroup,
    Folder,
    PhotosOnly,
    BroadExtensionGroupFilter,
    DateRange,
}

export interface FilterState {
    extensionGroupFilter: {
        selectedValue: Map<string, string>;
    };
    broadExtensionGroupFilter: {
        options: FileExtensionType[];
        selectedValue: FileExtensionType.Files | FileExtensionType.Images;
    } /* files/ images */;
    dateRangeFilter: {
        selectedValue: DateRangeFilter;
    };
    folderFilter: {
        selectedValue: string;
    };
    sizeFilter: {
        options: number[];
        selectedValue: number;
    };
    searchFilter: {
        selectedValue: string;
    };
    photosOnlyFilter: {
        selectedValue: boolean;
    };
}
